import React from "react";
import { SiteHeader } from "../components/layout/SiteHeader";
import { SiteFooter } from "../components/layout/SiteFooter";
import { Container } from "../components/layout/Container";

export function TermsPage() {
  return (
    <div className="relative flex min-h-screen w-full flex-col bg-background-dark text-white">
      <SiteHeader />
      <main className="flex-1 pt-28 pb-16">
        <Container>
          <div className="mx-auto max-w-3xl rounded-2xl border border-white/10 bg-white/[0.04] p-8 md:p-12">
            <h1 className="text-4xl font-black">Terms of Service</h1>
            <p className="mt-2 text-sm text-slate-500">Last updated: June 2026</p>
            <div className="mt-8 space-y-6 text-slate-300 leading-relaxed">
              <section>
                <h2 className="text-lg font-black text-white mb-2">1. Use of the service</h2>
                <p>Feuteuristix provides container load planning software. You may use the service for lawful logistics planning purposes only. You may not reverse-engineer, resell, or misuse the service.</p>
              </section>
              <section>
                <h2 className="text-lg font-black text-white mb-2">2. Account responsibilities</h2>
                <p>You are responsible for maintaining the security of your account credentials. You must not share API keys publicly. Notify us immediately of any unauthorised access.</p>
              </section>
              <section>
                <h2 className="text-lg font-black text-white mb-2">3. Simulation accuracy</h2>
                <p>Our engine provides optimised packing suggestions based on the input data you provide. The accuracy of results depends on the accuracy of your input. We do not guarantee that simulated plans will be achievable under all real-world loading conditions.</p>
              </section>
              <section>
                <h2 className="text-lg font-black text-white mb-2">4. Free plan limits</h2>
                <p>The Free plan includes 10 simulations per month. Unused simulations do not roll over. We reserve the right to change plan limits with 30 days notice.</p>
              </section>
              <section>
                <h2 className="text-lg font-black text-white mb-2">5. Termination</h2>
                <p>We may suspend accounts that violate these terms. You may delete your account at any time by contacting support.</p>
              </section>
              <section>
                <h2 className="text-lg font-black text-white mb-2">6. Limitation of liability</h2>
                <p>Feuteuristix is provided "as is." We are not liable for commercial losses arising from use of or inability to use the service.</p>
              </section>
              <section>
                <h2 className="text-lg font-black text-white mb-2">Contact</h2>
                <p>Questions about these terms: <a href="mailto:contact@feuteuristix.com" className="text-primary hover:underline">contact@feuteuristix.com</a>.</p>
              </section>
            </div>
          </div>
        </Container>
      </main>
      <SiteFooter />
    </div>
  );
}
